import parsePhoneNumberFromString, { isSupportedCountry } from 'libphonenumber-js';
import { z } from 'zod';
export const phoneNumberSchema = z.string().meta({ field: 'phone_number' });
export const countryCodeSchema = z
    .string()
    .optional()
    .meta({ field: 'country_code' })
    .refine((val) => !val || isSupportedCountry(val), {
    message: 'Invalid country code',
});
export const validatePhone = (ctx, fieldName, number, country) => {
    // CRM may provide a country code with no number; treat that as empty
    if (!number)
        return;
    if (!country) {
        ctx.addIssue({
            path: [fieldName],
            code: 'custom',
            message: 'Country code is required',
        });
        return;
    }
    const phone = parsePhoneNumberFromString(number, country);
    if (!phone || !phone.isValid()) {
        ctx.addIssue({
            path: [fieldName],
            code: 'custom',
            message: 'Invalid phone number and country code combination',
        });
    }
};
